// extracted by mini-css-extract-plugin
export default {"title":"ErrorPage_title__6x-wS","content":"ErrorPage_content__tD1YY"};